module.exports = __webpack_public_path__ + "static/media/twitter-logo.d25f0920.svg";